export default null;throw new Error("Unable to resolve \"./internal/streams/BufferList\" from npm:pngjs@5.0.0/browser.js");